export const getSearchPromptStyle = (theme) => ({
    minWidth: theme.isPhone() ? '20rem' : '15rem',
    width: '100%',
    padding: '0 .75rem',
});